export default __webpack_public_path__ + "static/media/alarm-clock.9446bf99.eot";